module.exports = __webpack_public_path__ + "static/media/bedroom.eec1be42.svg";